import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "moon-set-rise-text-small"
}
const _hoisted_2 = {
  key: 1,
  class: "moon-set-rise-text"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "pb-2 m-0" }, "Księżyc", -1)
const _hoisted_4 = {
  key: 0,
  class: "moon-rise-text"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "pe-1" }, "Wschód", -1)
const _hoisted_6 = {
  key: 1,
  class: "moon-set-text"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "pe-1" }, "Zachód", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoonEventDisplay = _resolveComponent("MoonEventDisplay")!

  return (_ctx.moonRise || _ctx.moonSet)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
      'position-absolute moon-set-rise-container': _ctx.isSmall,
      'position-relative moon-set-rise-container': !_ctx.isSmall,
    })
      }, [
        (_ctx.isSmall)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.isMoonRiseNext)
                ? (_openBlock(), _createBlock(_component_MoonEventDisplay, {
                    key: 0,
                    moonIsBeforeSet: _ctx.moonIsUp,
                    displayCondition: _ctx.displayCondition,
                    formattedMoonTime: _ctx.formattedMoonRiseTime,
                    timeToMoonEvent: _ctx.timeToMoonRise,
                    animate: true,
                    label: "Wschód"
                  }, null, 8, ["moonIsBeforeSet", "displayCondition", "formattedMoonTime", "timeToMoonEvent"]))
                : _createCommentVNode("", true),
              (_ctx.isMoonSetNext)
                ? (_openBlock(), _createBlock(_component_MoonEventDisplay, {
                    key: 1,
                    moonIsBeforeSet: _ctx.moonIsUp,
                    displayCondition: _ctx.displayCondition,
                    formattedMoonTime: _ctx.formattedMoonSetTime,
                    timeToMoonEvent: _ctx.timeToMoonSet,
                    animate: true,
                    label: "Zachód"
                  }, null, 8, ["moonIsBeforeSet", "displayCondition", "formattedMoonTime", "timeToMoonEvent"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.isMoonRiseNext)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_MoonEventDisplay, {
                      moonIsBeforeSet: _ctx.moonIsUp,
                      displayCondition: _ctx.displayCondition,
                      formattedMoonTime: _ctx.formattedMoonRiseTime,
                      timeToMoonEvent: _ctx.timeToMoonRise,
                      animate: !_ctx.moonIsUp,
                      inline: true
                    }, null, 8, ["moonIsBeforeSet", "displayCondition", "formattedMoonTime", "timeToMoonEvent", "animate"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isMoonSetNext)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_MoonEventDisplay, {
                      moonIsBeforeSet: _ctx.moonIsUp,
                      displayCondition: _ctx.displayCondition,
                      formattedMoonTime: _ctx.formattedMoonSetTime,
                      timeToMoonEvent: _ctx.timeToMoonSet,
                      animate: _ctx.moonIsUp,
                      inline: true
                    }, null, 8, ["moonIsBeforeSet", "displayCondition", "formattedMoonTime", "timeToMoonEvent", "animate"])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ], 2))
    : _createCommentVNode("", true)
}